/* eslint-disable react/no-array-index-key */
import React from 'react';
import Moment from 'moment';
import nacionalidades from '../../../api/nacionalidades';
import './lista-pasajeros.css';

const ListaPasajeros = (props) => {
  if (props === '') {
    return <div />;
  }

  function ObtenerPais(codigoPais) {
    const pais = nacionalidades.filter(({ id }) => id === codigoPais);
    return pais[0].descripcion;
  }

  const listaPasajeros = props.pasajeros.map((pasajero, indice) => (
    <div className='col-lg-6 col-md-6' key={indice}>
      <p>
        <span>
          <b>{`Pasajero ${indice + 1}:`}</b>
          {' '}
          <span>
            {' '}
            {`${pasajero.firstName} ${pasajero.lastName}`}
          </span>
        </span>
        <br />
        <span>
          <b>DNI:</b>
          {' '}
          <span>{pasajero.documentNumber}</span>
        </span>
        <br />
        <span>
          <b>Fecha de nacimiento: </b>
          <span>{Moment(pasajero.birthDate).format('DD/MM/YYYY')}</span>
        </span>
        <br />
        <span>
          <b>
            Sexo:
            {' '}
          </b>
          <span>
            {pasajero.gender.startsWith('M') ? 'Masculino' : 'Femenino'}
          </span>
        </span>
        <br />
        <span>
          <b>Nacionalidad: </b>
          <span>{ObtenerPais(pasajero.nationality)}</span>
        </span>
      </p>
    </div>
  ));

  return <div className='pasajero'>{listaPasajeros}</div>;
};

export default ListaPasajeros;
